var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"uppercase-status",class:[
    "tournament-status-icon-base",
    ("tournament-status-icon-" + (_vm.variant.type)) ]},[_vm._v("\n  "+_vm._s(_vm.variant.text)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }